import _ from 'lodash';
import React, { useState, useCallback, useRef, useEffect } from 'react';
import {useHistory} from 'react-router-dom';
import {toast} from 'react-toastify';
import { inject, observer } from 'mobx-react';
import { SubscriptionGrid } from './subscription-grid';

const ManageSubscriptions = ({subscriptionStore}) => {
	const history = useHistory();
	const onSelectionChange = useCallback((selected) => {
		//Navigate to the form for that subscription
		history.push(`/subscription/view/${selected}`)
	}, [])
	const [subscriptionItems, setSubscriptionItems] = useState(subscriptionStore.items);

	useEffect(() => {
			const fetchData = async () => {
				await subscriptionStore.fetchItems();
				setSubscriptionItems(subscriptionStore.items);
				setLoading(false);
			};
	
			fetchData();
		}, [subscriptionStore]);

	return (
		<SubscriptionGrid dataSource={subscriptionItems} onRowClick={(rowdata) => {onSelectionChange(rowdata._id)}}/>
	)
}

const injectWithStores = inject('subscriptionStore');

export default injectWithStores(({subscriptionStore}) => {
	return (
		<div>
            <div className="grid-x padding-top-1 padding-left-1">
                <div className="cell auto">
                    <h3 data-ta="mngSubscriptionsHeader">Manage Subscriptions</h3>
                </div>
            </div>
			<ManageSubscriptions subscriptionStore={subscriptionStore} />
		</div>
	)
})
